import { Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import { FC } from 'react';
import { CountryWithFlag } from 'ui/CountryWithFlag';
import { UserAvatar } from 'ui/UserAvatar';
import { useSelector } from 'react-redux';
import { getScripts } from 'redux/reducers/errorCorrections/selectors';
import { COLORS } from 'services/constants/colors';
import { IErrorCorrectionsScriptParameterValue, TErrorsParams } from '../types';

export type TStep3Props = {
	selectedScript: number;
	errorParams: IErrorCorrectionsScriptParameterValue[];
};
export const Step3: FC<TStep3Props> = ({ selectedScript, errorParams }) => {
	const scripts = useSelector(getScripts);

	return (
		<TableContainer
			sx={{
				'& .MuiTableCell-root': {
					border: 'none',
				},
			}}
		>
			<Table>
				<TableBody>
					<TableRow>
						<TableCell
							sx={{
								color: COLORS.font_status,
								p: '8px',
								fontWeight: 'bold',
							}}
						>
							Script:
						</TableCell>
						<TableCell sx={{ fontWeight: 'bold', color: COLORS.PRIMARY, p: '8px' }}>
							<Typography
								sx={{
									fontWeight: 'bold',
									fontSize: '0.9rem',
									backgroundColor: 'primary.light',
									borderRadius: '20px',
									padding: '4px 10px 4px 10px',
									width: 'fit-content',
								}}
							>
								{scripts?.[selectedScript].name}
							</Typography>
						</TableCell>
					</TableRow>
					<TableRow>
					<TableCell
						sx={{
							color: COLORS.font_status,
							p: '8px',
							fontWeight: 'bold',
						}}
					>
						Params:
					</TableCell>
					<TableCell
						sx={{
							fontWeight: 'bold',
							color: COLORS.PRIMARY,
							p: '8px',
						}}
						>
							{!errorParams.length ? 'No' : ''}
						</TableCell>
					</TableRow>
					{errorParams.length
						? errorParams?.map((param, index) => {
								return (
									<TableRow key={param.fieldName}>
									<TableCell
										sx={{
											color: COLORS.font_status,
											p: '8px',
											pl: '40px',
										}}
									>
										{param.name}:
									</TableCell>
									<TableCell
										sx={{ fontWeight: 'bold', color: COLORS.PRIMARY, p: '8px', fontSize: '1rem' }}
										>
											{param.type === 'country-code' ? (
												<CountryWithFlag countryCode={String(param.value ?? '')} bold />
											) : param.type === 'boolean' ? (
												param.value ? (
													'Yes'
												) : (
													'No'
												)
											) : (
												param.value
											)}
										</TableCell>
									</TableRow>
								);
							})
						: ''}
				</TableBody>
			</Table>
		</TableContainer>
	);
};
